import { apiFetch } from './client';

export const getDeskStatus = () =>
  apiFetch('/api/desk/status');

export const getObservationSamples = (obsId, limit = 500) =>
  apiFetch(`/api/desk/observations/${obsId}/samples?limit=${limit}`);

// Returns { observation_id, instruments: [{ role_label, ltp_at_lock, strike, option_type, ... }] }
export const getObservationInstruments = (obsId) =>
  apiFetch(`/api/desk/observations/${obsId}/instruments`);

// Returns always-current tick-store snapshot: futures_ltp, live_straddle/strangle,
// distance_from_atm, ng_market_live, socket state, restrike_status, per-leg ltps.
// NO Kite API call on backend — safe to poll every 30 s.
export const getObservationLive = (obsId) =>
  apiFetch(`/api/desk/observations/${obsId}/live`);

export const getNgCandles = (interval = '1h', n = 50) =>
  apiFetch(`/api/ng/candles?interval=${interval}&n=${n}`);

export const getNgIndicators = (n = 30) =>
  apiFetch(`/api/ng/indicators?n=${n}`);

export const getNgSignal    = () => apiFetch('/api/ng/signal');
export const getNgPaperBook = () => apiFetch('/api/ng/paper-book');

// Returns observations filtered by status: 'active' | 'ended' | 'all'
export const getObservationList = (status = 'active') =>
  apiFetch(`/api/desk/observations?status=${status}`);

// Always-current tick-store snapshot for NIFTY observations (nifty_decay / nifty_delta_decay).
// Per-leg ltp_now + age_seconds + iv/delta/theta computed from current tick.
// Returns market_live=false when equity market is closed or socket is down.
export const getNiftyObsLive = (obsId) =>
  apiFetch(`/api/desk/observations/${obsId}/nifty-live`);

// Recent socket lifecycle events from the socket_events DB table.
// n = max rows to return (newest first).
export const getSocketEvents = (n = 60) =>
  apiFetch(`/api/desk/socket-events?n=${n}`);
